<template>
	<div
		class="fixed z-50 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex flex-col justify-start min-h-screen pt-4 px-4 pb-20 text-center sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<!-- WTF????
            <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
            >&#8203;</span>-->

			<transition name="zoomin">
				<!--	todo prüfen kann weg? min-h-[90vh] -->
				<div
					class="self-center w-full md:max-w-screen-md NOTlg:max-w-screen-lg sm:my-[7.5%]"
				>
					<div class="fixed inset-0 self-center grayscale" v-if="!ready">
						<!-- loading spinner-->
						<!--
														 <img
																 class="animate-spin filter grayscale h-40 w-auto mx-auto"
																 :src="logoUrl"
																 alt="Loading"
																 v-if="!ready"
														 />
														 -->
						<ui-icon
							v-if="!ready"
							name="logo-wheat-only"
							class="animate-spin filter grayscale h-72 w-72 mx-auto"
							alt="Loading"
						/>
					</div>
					<div
						class="bg-white rounded-2xl overflow-hidden shadow-xl transform transition-all"
					>
						<iframe
							v-resize="{ log: false }"
							width="100%"
							class="NOTmin-h-[80vh]"
							:src="src"
							:class="[!ready ? 'h-0' : '']"
							frameborder="0"
						></iframe>
					</div>

				</div>
			</transition>
		</div>
	</div>
</template>

<script>

/**
 * @deprecated abgelöst durch Modal-Dialog
 *
 */
export default {
	props: {
		src: {
			type: String,
			required: true,
		},
		dismissible: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			open: false,
			ready: false,
			reload: false,
		};
	},
	mounted() {
		this.open = true;

		// safari hotfix: sometimes the message event does not seem to fire. if after a second we are not ready, then force ready.
		let that = this;
		setTimeout(function () {
			that.ready = true;
		}, 1000);
	},
	created() {
		let that = this;
		window.addEventListener("message", (event) => {
			/**
			 * through post message, we may receive a string with a long message that contains a json-encoded message from the
			 * iframe. the message from the iframe can be either a string or an array.
			 * example:
			 * [iFrameSizer]iFrameResizer0:0:0:message:["REDIRECT_TO:","https://example.org/cropui/public/start"]
			 */

			if (!event.data || typeof event.data != "string") {
				// not a relevant event for us
				return;
			}

			let message = null,
				params = [];

			try {
				let m = event.data.match("message:(.+)$"),
					unserialized = JSON.parse(m[1]);

				if (typeof unserialized == "string") {
					message = unserialized;
				} else {
					message = unserialized[0];
					params = unserialized;
					params.shift();
				}
			} catch (e) {
				return;
			}
			// console.log("ffffffff", event.data);
			console.log("GOT IFRAME MESSAGE", message, params);
			if (message == "FULL_RELOAD") {
				this.reload = true;
			}
			if (message == "READY_TO_RUMBLE") {
				// rendering is complete of the iframe
				that.ready = true;
			} else if (event.data.indexOf("REDIRECT_TO") > 0) {
				// close iframe and redirect to target url
				that.ready = false;
				let target = params[0];
				if (target == window.location.href) {
					console.log("IFRAME REDIRECT TO CURRENT URL: reload", target);
					that.$inertia.reload();
					that.open = false;
					that.$emit("close");
				} else {
					console.log("IFRAME REDIRECT", target);
					this.$inertia.visit(target);
				}
			}
		});
	},
	methods: {
		close() {
			if (!this.dismissible) {
				return false;
			}
			let that = this;
			setTimeout(function () {
				that.$inertia.reload();
				that.open = false;
				that.$emit("close");
			}, 300);
			that.ready = false;
		},
	},
	beforeDestroy() {
		if (this.reload == true) {
			window.location.reload();
		}
		document.body.classList.remove("overflow-hidden");
	},
	watch: {
		open(isOpen) {
			if (isOpen) {
				document.body.classList.add("overflow-hidden");
			} else {
				document.body.classList.remove("overflow-hidden");
			}
		},
	},
	computed: {
		logoUrl: () => window.baseUrl + "/images/cropspot-logo.svg",
	},
};
</script>

<style>
iframe.modal-dynamic-iframe {
	width: 1px;
	min-width: 100%;
}
</style>
